import { Injectable } from '@angular/core';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
	OnboardingApiKeyDTO,
	OnboardingApiKeyPayload,
	OnboardingPermissionsMapDTO,
	OnboardingStatusDTO,
} from '../../interfaces/onboarding.interface';

@Injectable({
	providedIn: 'root',
})
export class AzureOnboardingService {
	public onboardingPid: string;
	public cli: string;

	constructor(private apiFacade: ApiFacadeService) {}

	public getPermissionMap(): Observable<{ permissions_map: any; regions: any; template: any }> {
		const url = 'azure/dashboard/onboarding_monitoring/permissions_map';

		return this.apiFacade.get<OnboardingPermissionsMapDTO>(url).pipe(
			// Transforming response for legacy `OnboardingPermissionsTreeComponent`
			map((response) => ({
				permissions_map: response.all_permissions,
				regions: response.regions || [],
				template: {},
			})),
		);
	}

	public generateOnboardingApiKey(payload: OnboardingApiKeyPayload): Observable<OnboardingApiKeyDTO> {
		const url = 'azure/dashboard/onboarding_monitoring/generate_onboarding_cli';

		return this.apiFacade.post(url, payload);
	}

	public getOnboardingStatus(onboarding_pid: string): Observable<OnboardingStatusDTO> {
		const url = `azure/dashboard/onboarding_monitoring/onboarding_status/${onboarding_pid}`;

		return this.apiFacade.get(url);
	}
}
